var map = {
	"./de.json": 769295,
	"./en.json": 971381,
	"./es.json": 346637,
	"./fr.json": 947032,
	"./it.json": 233929,
	"./ja.json": 446011,
	"./ko.json": 265297,
	"./pl.json": 803100,
	"./pt.json": 526250,
	"./ru.json": 323375,
	"./uk.json": 316951
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 224077;